export default {
    'diagram3a3-6': {
        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
        'diagram-description': {
            '1': 'Policy uncertainty is bad for business',
            '2': 'When overall uncertainty increases, GDP falls: companies invest less, trade less, and hire fewer people; consumer spend less',
            '3': 'Uncertainty in government policy paralyzes, making business and consumers less sensitive to outside force',
            '4': 'Thus resources don\`t get reallocated, shutting down the primary mechanism for increasing productivity',
            '5': 'Because of the paralyzing effects, productive firms are slow to expand and unproductive firms are slow to contract',
            '6': 'So resources don’t get reallocated from the less productive to the more productive, shutting down the primary mechanism for increasing productivity',
        },
        'elements': {
            'one': 'Policy uncertainty is bad for business',
            'two': 'Uncertainty in government policy paralyzes, making business and consumers less sensitive to outside forces',
            'three': 'Because of the paralyzing effects, productive firms are slow to expand and unproductive firms are slow to contract',
            'four': 'Thus resources don\`t get reallocated, shutting down the primary mechanism for increasing productivity',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a3/diagram6/i18n/en.js